// Detect TikTok in-app browser
function isTikTokBrowser() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return userAgent.includes('musical_ly') || userAgent.includes('TikTok') || 
         userAgent.includes('Bytedance') || userAgent.includes('aweme');
}

if (!customElements.get("video-controls")) {
    customElements.define(
      "video-controls",
      class VideoControls extends HTMLElement {
        constructor() {
          super();
          this.isTikTok = isTikTokBrowser();
          
          // Log TikTok detection
          if (this.isTikTok) {
            console.log('TikTok detected in video-controls - disabling auto-play');
          }
        }
        

        connectedCallback() {
          this.video = this.querySelector("video");
          this.hasVideoClickToggle = this.dataset.videoClick === "false" ? false : true;
          this.productsContainer = this.querySelector(
            ".shoppable-video__products",
          );
          this.controlButton = this.querySelector(
            ".shoppable-video__control-button",
          );
          
          this.togglePlayPause = this.togglePlayPause.bind(this);
          this.toggleVideoIcon = this.toggleVideoIcon.bind(this);

          // SELECTIVE video controls for TikTok
          if (this.isTikTok && this.video) {
            // Check if this is a background/hero video (should play) vs modal video (should block)
            const isBackgroundVideo = this.video.hasAttribute('loop') || 
                                     this.video.hasAttribute('autoplay') ||
                                     this.closest('.hero') ||
                                     this.closest('.background-video');
            
            if (isBackgroundVideo) {
              console.log('✅ Allowing background video on TikTok (muted)');
              this.video.muted = true;
              this.video.setAttribute('playsinline', 'true');
              // Keep normal functionality for background videos
            } else {
              console.log('🚫 Disabling modal video controls for TikTok browser');
              this.video.muted = true;
              this.video.pause();
              this.video.preload = 'none';
              
              // Disable click events for modal videos only
              this.hasVideoClickToggle = false;
              return;
            }
          }

          this.addEventListeners();
          if(this.controlButton && this.video) this.toggleVideoIcon();
        }
        
        addEventListeners() {
          if(this.controlButton) this.controlButton.addEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.addEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.addEventListener("play", this.toggleVideoIcon);
            this.video.addEventListener("pause", this.toggleVideoIcon);
          }
        }
        
        removeEventListeners() {
          if(this.controlButton) this.controlButton.removeEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.removeEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.removeEventListener("play", this.toggleVideoIcon);
            this.video.removeEventListener("pause", this.toggleVideoIcon);
          }
        }

        toggleVideoIcon() {
          const isPlaying = !this.video.paused;
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--play",
            isPlaying,
          );
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--pause",
            !isPlaying,
          );
        }

        togglePlayPause(e) {
          e.preventDefault();
          const videoElement = this.video;      
          
          if (!videoElement) return;

          // BLOCK video play completely if from TikTok
          if (this.isTikTok) {
            console.log('Video play blocked - TikTok browser detected');
            videoElement.pause();
            videoElement.muted = true;
            return false;
          }

          if (videoElement.paused || videoElement.ended) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        }

        disconnectedCallback(){
          this.removeEventListeners();
        }

      },
    );
  }
  